import { catchError, tap } from 'rxjs/operators';
import { ToastService } from './../services/toast.service';
import { SpinnerService } from './../spinner/spinner.service';
import { UserAccountClient } from './../models/models.swagger.generated';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, ReactiveFormsModule } from '@angular/forms';
import { of } from 'rxjs';
import { AppErrorMessagesService } from '../services/app-error-messages.service';
import { ErrorType } from 'src/app/core/routing/error-types';
import { loginRoute } from 'src/app/core/routing/route-names';
import { TranslatePipe } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { AppErrorMessagesComponent } from '../error-messages/app-error-messages.component';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ReactiveFormsModule, AppErrorMessagesComponent, RouterLink, TranslatePipe]
})
export class ForgotPasswordComponent implements OnInit {

  constructor(
    private formBuilder: FormBuilder,
    private userAccountClient: UserAccountClient,
    private spinnerService: SpinnerService,
    private toastService: ToastService,
    private errorMessageService: AppErrorMessagesService
  ) { }

  public forgotPasswordForm!: FormGroup<{userName: FormControl<string | null>}>;
  public forgotPasswordSuccess = false;
  public loginRoute = loginRoute;

  public get formFields() {
    return this.forgotPasswordForm.controls;
  }

  public formSubmit() {
    if (this.forgotPasswordForm.valid) {
      this.spinnerService.show();
      const userName = this.forgotPasswordForm.value.userName;
      this.userAccountClient.forgotPassword(
        {
          username: userName
        } as any).pipe(
          tap(() => {
            this.spinnerService.hide();
            this.forgotPasswordSuccess = true;
          }),
          catchError((error: any) => {
            this.spinnerService.hide();
            this.handleError(error);
            return of(error);
          })
        ).subscribe();
    }
  }

  private handleError(error: any) {
    const apiErrorCode = this.errorMessageService.getApiErrorCode(error);
    let i18nErrorMessage = 'i18n.errors.server-error.message';
    const i18nErrorTitle = 'i18n.errors.server-error.title';
    if (apiErrorCode) {
      i18nErrorMessage = 'i18n.base.forgot-password.errors.' + apiErrorCode;
    }
    this.toastService.showError(i18nErrorTitle, i18nErrorMessage,
      '', ErrorType.serverError);
  }

  ngOnInit() {
    this.forgotPasswordForm = this.formBuilder.group({
      userName: this.formBuilder.control<string | null>(null, Validators.required)
    });
  }
}
